
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      meetings: [],
    };
  },
  computed: {
    homeTeam () {
      return this.getTeam(this.fixture, `Home`);
    },
    awayTeam () {
      return this.getTeam(this.fixture, `Away`);
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getMeetings();
    });
  },
  methods: {
    async getMeetings () {
      // Use date but not time to get meetings before the fixture
      const date = this.getDate(this.fixture.datetime, `YYYY-MM-DD`);

      const params = {
        "other_team_id": this.awayTeam.teamId,
        "datetime": date,
        "limit": 5,
      };

      const request = await this.$getCustomStats(`previous-meeting/${this.homeTeam.teamId}`, params);
      if (request !== null) {
        this.meetings = request;
      }
    },
    getHomeTeam (meeting) {
      const meetingHomeTeam = meeting.teams.team.side.name === `Home` ? meeting.teams.team : meeting.teams.otherTeam;

      if (meetingHomeTeam.teamId === this.homeTeam.teamId) {
        return this.homeTeam.team; // Return current fixture home team if they were home in the meeting
      }
      return this.awayTeam.team; // Return current fixture away team
    },
    getAwayTeam (meeting) {
      const meetingAwayTeam = meeting.teams.team.side.name === `Away` ? meeting.teams.team : meeting.teams.otherTeam;

      if (meetingAwayTeam.teamId === this.awayTeam.teamId) {
        return this.awayTeam.team; // Return current fixture away team if they were away in the meeting
      }
      return this.homeTeam.team; // Return current fixture home team
    },
    getHomeScore (meeting) {
      const meetingHomeTeam = meeting.teams.team.side.name === `Home` ? meeting.teams.team : meeting.teams.otherTeam;
      return meetingHomeTeam.score;
    },
    getAwayScore (meeting) {
      const meetingAwayTeam = meeting.teams.team.side.name === `Away` ? meeting.teams.team : meeting.teams.otherTeam;
      return meetingAwayTeam.score;
    },
  },
};
